// stocai_frontend/src/components/HomePage/components/widgets/Module7/Steps/ComparisonScreen.jsx

import React, { useEffect, useState } from "react";
import bgFutureImg from "../../../../../../assets/bg_future.png";
import FutureIdentityCard from "../../Identity/FutureYou/FutureIdentityCard";
import FuturePersonaCard from "../FuturePersonaCard";
import { progressService } from "../../../../../../services/progressService";
import ConfettiLayer from "../../../Celebration/ConfettiLayer";
import { celebrationThemes } from "../../../Celebration/celebrationThemes";

const FUTURE_IDENTITY_SUBSECTION_ID = "a6f1a312-7580-4988-8cc2-64d342be7ab3";
const CURRENT_IDENTITY_SUBSECTION_ID = "f90552a1-12fd-4f0b-b4f5-17e258b84b97";

const ComparisonScreen = ({ userId, subsectionId, onNextStep }) => {
  const [futureData, setFutureData] = useState(null);
  const [personaData, setPersonaData] = useState({
    behaviours: [],
    beliefs: [],
    risks: [],
  });

  const [showConfetti, setShowConfetti] = useState(true);
  const currentTheme =
    celebrationThemes.meeting_personality || celebrationThemes.default;

  useEffect(() => {
    const t = setTimeout(() => setShowConfetti(false), 4000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!userId || !subsectionId) return;

    async function loadAll() {
      try {
        const vizRec = await progressService.getUserProgress(userId, subsectionId);
        const vizPayload = vizRec?.data?.payload || vizRec?.data || {};

        setPersonaData({
          behaviours: Array.isArray(vizPayload.behaviours)
            ? vizPayload.behaviours
            : [],
          beliefs: Array.isArray(vizPayload.beliefs) ? vizPayload.beliefs : [],
          risks: Array.isArray(vizPayload.risks) ? vizPayload.risks : [],
        });

        const [futureIdentityRec, currentIdentityRec] = await Promise.all([
          progressService.getUserProgress(userId, FUTURE_IDENTITY_SUBSECTION_ID),
          progressService.getUserProgress(userId, CURRENT_IDENTITY_SUBSECTION_ID),
        ]);

        const futurePayload =
          futureIdentityRec?.data?.payload || futureIdentityRec?.data || {};
        const currentPayload =
          currentIdentityRec?.data?.payload || currentIdentityRec?.data || {};

        setFutureData({
          userName: currentPayload.userName || "User",
          profileImageUrl: currentPayload.profileImage || "",
          designation:
            futurePayload.designation ||
            futurePayload.futureTitle ||
            currentPayload.currentTitle ||
            "Your Role",
          salary: futurePayload.salary || currentPayload.salary || "",
          timeline: futurePayload.timeline || "",
          location:
            futurePayload.location ||
            currentPayload.location ||
            "",
          knownFor: Array.isArray(futurePayload.knownFor)
            ? futurePayload.knownFor
            : [],
          futureVoiceNote:
            currentPayload.futureVoiceNote ||
            futurePayload.futureVoiceNote ||
            "",
        });
      } catch (err) {
        console.error("Error loading comparison data:", err);
      }
    }

    loadAll();
  }, [userId, subsectionId]);

  if (!futureData) return <div className="p-10">Loading...</div>;

  return (
    <div
      className="
        relative
        w-full h-full flex flex-col items-center px-4
        overflow-y-auto overflow-x-hidden
        scrollbar-thin scrollbar-thumb-transparent scrollbar-track-transparent
      "
    >
      {/* Confetti overlay */}
      {showConfetti && (
        <ConfettiLayer colors={currentTheme.confettiColors} />
      )}

      <div
        className="relative w-full max-w-5xl flex flex-col items-center pb-8"
        style={{
          backgroundImage: `url(${bgFutureImg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "contain",
        }}
      >
        {/* Content */}
        <div className="relative z-[1] flex flex-col items-center text-center px-4 pt-6">
          <h2
            style={{
              fontFamily: "Gotham",
              fontWeight: 500,
              fontSize: "32px",
              lineHeight: "135%",
              letterSpacing: "0%",
              color: "#000000",
            }}
          >
            Your Future Self is now clearer than ever!
          </h2>

          <p
            className="mt-2 max-w-2xl"
            style={{
              fontFamily: "Gotham",
              fontWeight: 400,
              fontSize: "19px",
              lineHeight: "150%",
              letterSpacing: "0%",
              textAlign: "center",
              color: "#323232",
            }}
          >
            Your future self already exists.
            <br />
            Now take action to become them.
          </p>

          {/* Cards Container - Fixed dimensions wrapper */}
          <div className="mt-6 flex justify-center gap-28 mb-6 flex-nowrap">
            {/* Wrapper for FutureIdentityCard with fixed dimensions */}
            <div 
              style={{
                width: "429px",
                height: "712px",
              }}
            >
              <FutureIdentityCard
                futureData={futureData || {}}
                userName={futureData?.userName || "User"}
                profileImage={futureData?.profileImageUrl}
                currentInput=""
                coreValues={[]}
                showCoreValues={false}
              />
            </div>

            <FuturePersonaCard
              behaviours={personaData.behaviours}
              beliefs={personaData.beliefs}
              risks={personaData.risks}
            />
          </div>

          {/* Button - Centered */}
          <button
            type="button"
            onClick={onNextStep}
            className="
              flex items-center justify-between
              w-full max-w-[429px]
              h-[56px]
              ml-[544px]
              rounded-[16.2px]
              bg-[#000000]
              px-[16.2px] py-[17.82px]
              text-white
              hover:bg-[#1a1a1a]
              transition-colors
            "
          >
            <span
              style={{
                fontFamily: "Gotham",
                fontWeight: 350,
                fontSize: "17.01px",
                lineHeight: "100%",
                letterSpacing: "0%",
              }}
              className="font-gotham"
            >
              Next: Your Journey So Far
            </span>
            <span
              className="
                flex items-center justify-center
                w-[20px] h-[20px]
                rounded-full
                bg-white text-black
              "
            >
              <svg width={10} height={10} viewBox="0 0 20 20" fill="none">
                <path
                  d="M8 5l4 5-4 5"
                  stroke="#151A1F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComparisonScreen;


// // stocai_frontend/src/components/HomePage/components/widgets/Module7/Steps/ComparisonScreen.jsx

// import React, { useEffect, useState } from "react";
// import bgFutureImg from "../../../../../../assets/bg_future.png";
// import FutureIdentityCard from "../../Identity/FutureYou/FutureIdentityCard";
// import FuturePersonaCard from "../FuturePersonaCard";
// import { progressService } from "../../../../../../services/progressService";
// import ConfettiLayer from "../../../Celebration/ConfettiLayer";
// import { celebrationThemes } from "../../../Celebration/celebrationThemes";

// const FUTURE_IDENTITY_SUBSECTION_ID = "a6f1a312-7580-4988-8cc2-64d342be7ab3";
// const CURRENT_IDENTITY_SUBSECTION_ID = "f90552a1-12fd-4f0b-b4f5-17e258b84b97";

// const ComparisonScreen = ({ userId, subsectionId, onNextStep }) => {
//   const [futureData, setFutureData] = useState(null);
//   const [personaData, setPersonaData] = useState({
//     behaviours: [],
//     beliefs: [],
//     risks: [],
//   });

//   // confetti state (reuse meeting_personality theme or pick another)
//   const [showConfetti, setShowConfetti] = useState(true);
//   const currentTheme =
//     celebrationThemes.meeting_personality || celebrationThemes.default;

//   useEffect(() => {
//     const t = setTimeout(() => setShowConfetti(false), 4000);
//     return () => clearTimeout(t);
//   }, []);

//   useEffect(() => {
//     if (!userId || !subsectionId) return;

//     async function loadAll() {
//       try {
//         const vizRec = await progressService.getUserProgress(userId, subsectionId);
//         const vizPayload = vizRec?.data?.payload || vizRec?.data || {};

//         setPersonaData({
//           behaviours: Array.isArray(vizPayload.behaviours)
//             ? vizPayload.behaviours
//             : [],
//           beliefs: Array.isArray(vizPayload.beliefs) ? vizPayload.beliefs : [],
//           risks: Array.isArray(vizPayload.risks) ? vizPayload.risks : [],
//         });

//         const [futureIdentityRec, currentIdentityRec] = await Promise.all([
//           progressService.getUserProgress(userId, FUTURE_IDENTITY_SUBSECTION_ID),
//           progressService.getUserProgress(userId, CURRENT_IDENTITY_SUBSECTION_ID),
//         ]);

//         const futurePayload =
//           futureIdentityRec?.data?.payload || futureIdentityRec?.data || {};
//         const currentPayload =
//           currentIdentityRec?.data?.payload || currentIdentityRec?.data || {};

//         setFutureData({
//           userName: currentPayload.userName || "User",
//           profileImageUrl: currentPayload.profileImage || "",
//           designation:
//             futurePayload.designation ||
//             futurePayload.futureTitle ||
//             currentPayload.currentTitle ||
//             "Your Role",
//           salary: futurePayload.salary || currentPayload.salary || "",
//           timeline: futurePayload.timeline || "",
//           location:
//             futurePayload.location ||
//             currentPayload.location ||
//             "",
//           knownFor: Array.isArray(futurePayload.knownFor)
//             ? futurePayload.knownFor
//             : [],
//           futureVoiceNote:
//             currentPayload.futureVoiceNote ||
//             futurePayload.futureVoiceNote ||
//             "",
//         });
//       } catch (err) {
//         console.error("Error loading comparison data:", err);
//       }
//     }

//     loadAll();
//   }, [userId, subsectionId]);

//   if (!futureData) return <div className="p-10">Loading...</div>;

//   return (
//     <div
//       className="
//         relative
//         w-full h-full flex flex-col items-center px-4
//         overflow-y-auto overflow-x-hidden
//         scrollbar-thin scrollbar-thumb-transparent scrollbar-track-transparent
//       "
//     >
//       {/* Confetti overlay (same pattern as CelebrationScreen) */}
//       {showConfetti && (
//         <ConfettiLayer colors={currentTheme.confettiColors} />
//       )}

//       <div
//         className="relative w-full max-w-5xl flex flex-col items-center pb-16"
//         style={{
//           backgroundImage: `url(${bgFutureImg})`,
//           backgroundRepeat: "no-repeat",
//           backgroundPosition: "center center",
//           backgroundSize: "758.0339px 874.6545px",
//         }}
//       >
//         {/* content */}
//         <div className="relative z-[1] flex flex-col items-center text-center px-4 pt-10">
//           <h2
//             style={{
//               fontFamily: "Gotham",
//               fontWeight: 500,
//               fontSize: "32px",
//               lineHeight: "135%",
//               letterSpacing: "0%",
//               color: "#000000",
//             }}
//           >
//             Your Future Self is now clearer than ever!
//           </h2>

//           <p
//             className="mt-3 max-w-2xl"
//             style={{
//               fontFamily: "Gotham",
//               fontWeight: 400,
//               fontSize: "19px",
//               lineHeight: "165%",
//               letterSpacing: "0%",
//               textAlign: "center",
//               color: "#323232",
//             }}
//           >
//             Your future self already exists.
//             <br />
//             Now take action to become them.
//           </p>

//           <div className="mt-6 flex justify-center gap-28 mb-4 flex-wrap">
//             <FutureIdentityCard
//               futureData={futureData || {}}
//               userName={futureData?.userName || "User"}
//               profileImage={futureData?.profileImageUrl}
//               currentInput=""
//               coreValues={[]}
//               showCoreValues={false}
//             />

//             <FuturePersonaCard
//               behaviours={personaData.behaviours}
//               beliefs={personaData.beliefs}
//               risks={personaData.risks}
//             />
//           </div>

//           <button
//             type="button"
//             onClick={onNextStep}
//             className="
//               flex items-center justify-between
//               w-[429px] h-[56px]
//               ml-[504px]
//               rounded-[16.2px]
//               bg-[#000000]
//               px-[16.2px] py-[17.82px]
//               text-white
//             "
//           >
//             <span
//               style={{
//                 fontFamily: "Gotham",
//                 fontWeight: 350,
//                 fontSize: "17.01px",
//                 lineHeight: "100%",
//                 letterSpacing: "0%",
//               }}
//               className="font-gotham"
//             >
//               Next: Your Journey So Far
//             </span>
//             <span
//               className="
//                 flex items-center justify-center
//                 w-[20px] h-[20px]
//                 rounded-full
//                 bg-white text-black
//               "
//             >
//               <svg width={10} height={10} viewBox="0 0 20 20" fill="none">
//                 <path
//                   d="M8 5l4 5-4 5"
//                   stroke="#151A1F"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ComparisonScreen;